export default "__VITE_ASSET__DdB5_Cv___"